module["exports"] = [
  "s.r.o.",
  "a.s.",
  "v.o.s."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/company/suffix.js
// module id = 1200
// module chunks = 0